export default "__VITE_ASSET__CFADU4kp__"